module.exports = __webpack_public_path__ + "static/media/saved_successfully.cf34508e.svg";